import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { inventoryDestinationList, riskMgmtInternalTicketListAction } from "../../../modules/riskmanagement/action";
import CreateTable from "../../CreateTable";
import Loader from "../../Loader";



class InternalDest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headerRows: {
        loadDate: "Load Date",
        ticketNumber: "Ticket Number",
        loadNumber: "Load Number",
        // incommingFieldEstimatedLoadBushels: "Est. Load Bushels",
        // incommingEstimatedHomeScaleShrinkBushels:
        //   "Recieved Payload Net Destination Bushels",
        // receivedNetBushels: "Recieved Net Bushels",
        // balance: "Balance",
        // status: "Status"
        incommingEstimatedHomeScaleShrinkBushels:
          "Incoming Estimated Home Scale Shrunk Bushels",
        incommingFieldEstimatedLoadBushels:
          "Incoming Field Estimated Load Bushels",
        outgoingEstimatedHomeScaleShrinkBushels:
          "Outgoing Estimated Home Scale Shrunk Bushels",
        outgoingFieldEstimatedLoadBushels:
          "Outgoing Field Estimated Load Bushels"
      },
      order: "desc",
      orderBy: "id",
      headers: {},
      dataRows: [],
      fetchingComplete: false
    };
  }

  componentWillMount() {
    const {
      internalInventoryDest = [],
      typeId,
      queryParam,
      invetoryList
    } = this.props;
    this.props.inventoryDestinationList(queryParam).then(data => {
      if (data) {
        this.createRowData(internalInventoryDest, this.props.typeId);
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.internalInventoryDest &&
      this.props.internalInventoryDest !== nextProps.internalInventoryDest &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true }, () => {
        this.createRowData(nextProps.internalInventoryDest, this.props.typeId);
      });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
  }

  createRowData = (internalInventoryDest=[], typeId) => {
    let filteredArr =
      internalInventoryDest.filter(filtered => 
        filtered.destinationType === typeId
      );

    let data =
      filteredArr.map(data => {
        let obj = {};
        var date = new Date(data.loadDate);
        obj["loadDate"] = data.loadDate ? moment(date).format("lll") : "NIL";
        obj["ticketNumber"] = data.ticketNumber;
        obj["incommingEstimatedHomeScaleShrinkBushels"] =
          data.incommingEstimatedHomeScaleShrinkBushels;
        obj["loadNumber"] = data.loadNumber;
        obj["incommingFieldEstimatedLoadBushels"] =
          data.incommingFieldEstimatedLoadBushels;
        obj["receivedNetBushels"] =
          data.reconciliation && data.reconciliationreceivedNetBushels;

        obj["balance"] = data.reconciliation
          ? data.reconciliation.incommingEstimatedHomeScaleShrinkBushels
            ? parseFloat(
                data.incommingFieldEstimatedLoadBushels -
                  data.reconciliation.incommingEstimatedHomeScaleShrinkBushels
              ).toFixed(2)
            : parseFloat(
                data.incommingFieldEstimatedLoadBushels -
                  data.reconciliation.receivedNetBushels
              ).toFixed(2)
          : "";
        obj["estimatedHomeScaleShrinkBushels"] =
          data.estimatedHomeScaleShrinkBushels;
        obj["incommingFieldEstimatedLoadBushels"] =
          data.incommingFieldEstimatedLoadBushels;

        obj["outgoingEstimatedHomeScaleShrinkBushels"] =
          data.outgoingEstimatedHomeScaleShrinkBushels;

        obj["outgoingFieldEstimatedLoadBushels"] =
          data.outgoingFieldEstimatedLoadBushels;

        obj["status"] = data.status;
        return obj;
      });
    return data;
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };

  render() {
    const { invetoryList, typeId, fetchingComplete } = this.props;
    const { headerRows, order, orderBy, dataRows } = this.state;
    return (
      <div className=" ticket-body">
        {fetchingComplete ? (
          invetoryList && (
            <CreateTable
              order={order}
              orderBy={orderBy}
              headerRows={headerRows}
              rowData={this.createRowData(invetoryList,typeId)}
              onClick={() => {}}
              onRequestSort={this.handleRequestSort}
              isMenuRequired={false}
              highlightPrimaryColumn={true}
            />
          )
        ) : (
          <Loader />
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    invetoryList: state.riskReducer.internalInventoryDest,
    fetchingComplete: state.riskReducer.fetchingComplete
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      inventoryDestinationList,
      riskMgmtInternalTicketListAction
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalDest);



// WEBPACK FOOTER //
// ./src/components/private/RiskManagement/InternalDest.js